const TODAY = 'TODAY';
const YESTERDAY = 'YESTERDAY';
const LAST_SEVEN_DAYS = 'LAST_SEVEN_DAYS';
const LAST_THIRTY_DAYS = 'LAST_THIRTY_DAYS';
const CUSTOM = 'CUSTOM';
const LAST_WEEK = 'LAST_WEEK';
const LAST_MONTH = 'LAST_MONTH';
const THIS_MONTH = 'THIS_MONTH';
const THIS_WEEK = 'THIS_WEEK';
const LAST_30_DAYS = 'LAST_30_DAYS';
const SPLIT_DATE = 1554066000000; // April 1st, 2019
const SPLIT_DATE_STR = 'April 1, 2019';

export {
  TODAY,
  YESTERDAY,
  LAST_SEVEN_DAYS,
  LAST_THIRTY_DAYS,
  CUSTOM,
  LAST_WEEK,
  LAST_MONTH,
  THIS_WEEK,
  THIS_MONTH,
  LAST_30_DAYS,
  SPLIT_DATE,
  SPLIT_DATE_STR
};
